var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportCollaborators43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 28.0016C32.5 28.0016 30.3 25.9016 29.4 23.0016C28.7 23.0016 28.1 22.2016 28 21.1016C27.9 20.1016 28.4 19.2016 29 19.0016C29.2 15.0016 30.3 12.6016 34.3 12.6016C38.3 12.6016 39.5 15.0016 39.6 19.0016C40.2 19.2016 40.7 20.0016 40.6 21.1016C40.5 22.2016 39.9 23.0016 39.2 23.0016C38.5 25.9016 36.3 28.0016 34.4 28.0016Z",
    stroke: "#4E4B45",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 25.7031C42.7 26.7031 45.8 28.9031 45.8 33.4031C42.8 34.8031 38.3 35.4031 34.4 35.4031C30.5 35.4031 26 34.8031 23 33.4031C23 28.9031 26.1 26.7031 30.4 25.7031",
    stroke: "#4E4B45",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 29.5C15.1 29.5 12.1 26.6 10.9 22.6C9.9 22.6 9.1 21.4 9 20C8.9 18.6 9.5 17.4 10.4 17.2C10.6 11.7 12.2 8.5 17.7 8.5C23.2 8.5 24.7 11.8 25 17.2C25.9 17.4 26.5 18.6 26.4 20C26.3 21.5 25.5 22.6 24.5 22.6C23.3 26.6 20.3 29.5 17.7 29.5Z",
    stroke: "#010101",
    strokeWidth: 1.8287,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 26.3008C29.1 27.7008 33.3 30.7008 33.3 36.8008C29.2 38.7008 23.1 39.5008 17.8 39.5008C12.4 39.5008 6.39999 38.6008 2.29999 36.8008C2.29999 30.7008 6.49999 27.7008 12.4 26.3008",
    stroke: "#010101",
    strokeWidth: 1.8287,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 26.3008C29.1 27.7008 33.3 30.7008 33.3 36.8008C29.2 38.7008 23.1 39.5008 17.8 39.5008C12.4 39.5008 6.39999 38.6008 2.29999 36.8008C2.29999 30.7008 6.49999 27.7008 12.4 26.3008",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 26.3008C29.1 27.7008 33.3 30.7008 33.3 36.8008C29.2 38.7008 23.1 39.5008 17.8 39.5008C12.4 39.5008 6.39999 38.6008 2.29999 36.8008C2.29999 30.7008 6.49999 27.7008 12.4 26.3008",
    stroke: "#4E4B45",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 29.5C15.1 29.5 12.1 26.6 10.9 22.6C9.9 22.6 9.1 21.4 9 20C8.9 18.6 9.5 17.4 10.4 17.2C10.6 11.7 12.2 8.5 17.7 8.5C23.2 8.5 24.7 11.8 25 17.2C25.9 17.4 26.5 18.6 26.4 20C26.3 21.5 25.5 22.6 24.5 22.6C23.3 26.6 20.3 29.5 17.7 29.5Z",
    fill: "white",
    stroke: "#4E4B45",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportCollaborators43);
export default __webpack_public_path__ + "static/media/icons-2_export-COLLABORATORS-43.a4a7d12ee851febcaa93c5fc134609e3.svg";
export { ForwardRef as ReactComponent };